module.exports = __webpack_public_path__ + "static/media/sprzedaz.01f6d414.svg";